/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type DashboardCharts_statscards$ref: FragmentReference;
declare export opaque type DashboardCharts_statscards$fragmentType: DashboardCharts_statscards$ref;
export type DashboardCharts_statscards = {|
  +aggregate: ?{|
    +commissionTotal: number,
    +ordersCount: number,
    +clickCount: number,
    +revenueTotal: number,
  |},
  +$refType: DashboardCharts_statscards$ref,
|};
export type DashboardCharts_statscards$data = DashboardCharts_statscards;
export type DashboardCharts_statscards$key = {
  +$data?: DashboardCharts_statscards$data,
  +$fragmentRefs: DashboardCharts_statscards$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DashboardCharts_statscards",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AggregatedStats",
      "kind": "LinkedField",
      "name": "aggregate",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "commissionTotal",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ordersCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "clickCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "revenueTotal",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ActivityStats",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '21873f390488867cd7936b1785b3f6aa';

module.exports = node;
